export default __webpack_public_path__ + "static/media/photo--sm--kara10.6606a06c.jpg";